import React from 'react';

function Step() {
    const onboardingDescriptions = [
        {
            id: 1,
            text: "Here you will receive your caseload from Khan Communication Services and review the agency's policies."
        },
        {
            id: 2,
            text: "You can track your client's progress and create reports."
        },
        {
            id: 3,
            text: "You will also have access to a support staff dashboard where you can assign tasks to assistants and track their work with your clients."
        }
    ];

    return (
        <div style={{ marginTop: '35px' }}>
            <div className="d-flex flex-column align-items-center">
                <ul className="w-75 p-0">
                    {/* {onboardingDescriptions.map((item) => (
                        <li key={item.id} className="welcome-list">
                            {item.text}
                        </li>
                    ))} */}
                    <li className="welcome-list"> Here you will be able to access tasks and resources to use with clients you are working with. You can track a client’s progress and share information with your supervising clinician in a secure secure dashboard that meets HIPAA compliance.  
                         {/* You may read our terms and conditions here and our privacy policy here.  */}
                          </li>

                </ul>
            </div>
            {/* <div className="d-flex flex-column justify-content-start align-items-center">
                <p className='w-75 welcome-list'>
                    By selecting I AGREE you have accepted our terms and conditions and our privacy policy.
                </p>
            </div> */}
        </div>
    );
}

export default Step;
